'use client';
import Link from 'next/link';
import { track } from '@/app/lib/track';

interface Props {
  href: string;
  newTab?: boolean;
  label: string;
  component?: string;
  event?: string;
  className?: string;
  children: React.ReactNode;
}

export default function ClickTrackLink({ href, newTab, label, component = '', event = 'click', className, children }: Props) {
  return (
    <Link
      href={href}
      target={newTab ? '_blank' : undefined}
      rel={newTab ? 'noopener noreferrer' : undefined}
      className={className}
      onClick={() => {
        try { track(event, { label, component }, { event, label, component }); } catch {}
      }}
    >
      {children}
    </Link>
  );
}
